import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MyOrdersRepository } from '../repositories/my-orders.repository';
import { CustomerOrderModel } from '../models/customer-order.model';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MyOrdersService {


  constructor(
    private myOrdersRepository: MyOrdersRepository, private authService: AuthService) { }


  public getOrders(doc: string, email: string, tokenRecaptcha: string | null, params?: any): Observable<CustomerOrderModel[]> {
    return this.myOrdersRepository.getOrders(doc, email, tokenRecaptcha, params)
      .pipe(map(res => {
        const orders: CustomerOrderModel[] = [];
        res.events?.forEach((event: any, index: number) => {
          event.orders.forEach((order: any) => {
            const tickets: any[] = [];
            order["canRetransfer"] = event["canRetransfer"]
            order["blockTransfer"] = event["blockTransfer"]
            order.tickets.forEach((ticket: any) => {

              const index = tickets.findIndex((t) => {
                return t.id == ticket.ticketId
              });

              let recievedTicket

              if (index === -1) {
                if (ticket.transferPreviousCustomerId != null && ticket.transferPreviousCustomerId == this.authService.getCustomer()['id']) {
                  recievedTicket = false
                } else {
                  recievedTicket = true
                }

                tickets[tickets.length] = {
                  ticketId: ticket.ticketId,
                  id: ticket.id,
                  sectorId: ticket.sectorId,
                  pdvId: order.pdvId,
                  dateTicketId: ticket.dateTicketId,
                  name: ticket.ticket.name,
                  sector: ticket.sector.name,
                  fee: ticket.priceFinalFee,
                  customerComissionerId: ticket.customerComissionerId,
                  customerId: ticket.customerId,
                  transferDate: ticket.transferDate,
                  recievedTicket: recievedTicket,
                  transferPreviousCustomerId: ticket.transferPreviousCustomerId,
                  transferPreviousCustomer: ticket.transferPreviousCustomer,
                  customer: ticket.customer,
                  price: ticket.priceFinal - ticket.priceFinalFee,
                  qty: 1
                }

              } else {
                tickets[index].qty++;
              }

            });

            // if (order.has_mail) {
            orders.push({
              id: order.id,
              eventId: event.id,
              pdvId: order.pdvId,
              canRetransfer: order.canRetransfer,
              blockTransfer: order.blockTransfer,
              eventName: event.name,
              image: event.imageWeb,
              code: order.autoincrement,
              additionalData: order.payments.length >= 1 ? order.payments[0].additionalData : null,
              createdAt: order.createdAt,
              status: order.status,
              producerOwnerId: event.producerOwnerId,
              quantityTickets: order.tickets.length,
              amount: order.amount,
              link: order.link,
              holder: order.holder,
              canRefund: order.canRefund,
              tickets: tickets
            });
            // }

          });

        });

        let orders_filter

        orders_filter = orders.filter(function (res): any {
          if (res.producerOwnerId != "de96f90b-b220-4592-867c-6ddec97b0139" && res.producerOwnerId != "b21dee9f-67e3-4996-9c7c-929cf073f3c8") {
            return res
          } else {
            if (res.status != "Canceled") {
              return res
            }
          }
        })

        orders_filter = orders_filter.sort((a, b) => {
          const codeA = a.code ?? 0;
          const codeB = b.code ?? 0;
          return codeB - codeA;
        });

        return orders_filter;
      }));
  }


  public getOrdersWithoutLogin(doc: string, email: string, tokenRecaptcha: string, params?: any): Observable<CustomerOrderModel[]> {
    return this.myOrdersRepository.getOrders(doc, email, tokenRecaptcha, params)
      .pipe(map(res => {
        const orders: CustomerOrderModel[] = [];
        res.events?.forEach((event: any, index: number) => {
          event.orders.forEach((order: any) => {
            const tickets: any[] = [];

            order.tickets.forEach((ticket: any) => {
              const index = tickets.findIndex((t) => {
                return t.id == ticket.ticketId
              });

              if (index < 0) {

                tickets[tickets.length] = {
                  ticketId: ticket.ticketId,
                  id: ticket.id,
                  pdvId: order.pdvId,
                  dateTicketId: ticket.dateTicketId,
                  name: ticket.ticket.name,
                  sector: ticket.sector.name,
                  fee: ticket.priceFinalFee,
                  customerComissionerId: ticket.customerComissionerId,
                  customerId: ticket.customerId,
                  transferDate: ticket.transferDate,
                  transferPreviousCustomerId: ticket.transferPreviousCustomerId,
                  transferPreviousCustomer: ticket.transferPreviousCustomer,
                  customer: ticket.customer,
                  price: ticket.priceFinal - ticket.priceFinalFee,
                  qty: 1
                }

              } else {
                tickets[index].qty++;
              }

            });

            // if (order.has_mail) {
            orders.push({
              id: order.id,
              eventId: event.id,
              pdvId: order.pdvId,
              eventName: event.name,
              image: event.imageWeb,
              code: order.autoincrement,
              additionalData: order.payments.length >= 1 ? order.payments[0].additionalData : null,
              createdAt: order.createdAt,
              status: order.status,
              producerOwnerId: event.producerOwnerId,
              quantityTickets: order.tickets.length,
              amount: order.amount,
              link: order.link,
              holder: order.holder,
              canRefund: order.canRefund,
              tickets: tickets
            });
            // }

          });

        });
        return orders;
      }));
  }



  public getCustomerOrders(doc: string, email: string, tokenRecaptcha: string | null, params?: any): Observable<CustomerOrderModel[]> {
    return this.myOrdersRepository.getOrders(doc, email, tokenRecaptcha, params)
  }

  public cancel(orderId: string): Observable<any> {
    return this.myOrdersRepository.cancel(orderId);
  }

  public transferTicket(ticketId: string, cpf: string, tokenRecaptcha: string): Observable<any> {
    return this.myOrdersRepository.transferTicket(ticketId, cpf, tokenRecaptcha);
  }

}
